import React, { useMemo, useState } from 'react'
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap'
import useTiltEffect from '../hooks/useTiltEffect';

import 'animate.css';
import TrackVisibility from 'react-on-screen';

// React / personal project previews
import gameCommerceImg from '../assets/img/projects/game-commerce.jpg'
import pokedexImg from '../assets/img/projects/pokedex.jpg'
import freakGeekImg from '../assets/img/projects/freak-geek.jpg'
import acEstudioImg from '../assets/img/projects/ac-estudio.jpg'

// Client site screenshots
import rankoImg from '../assets/img/projects/ranko-home.gif'
import trompoImg from '../assets/img/projects/trompo.gif'
import hummingImg from '../assets/img/projects/humming-ezgif.com-animated-gif-maker.gif'
import iwalkImg from '../assets/img/projects/iwalkwithu.gif'
import eonImg from '../assets/img/projects/eon-home-ezgif.com-animated-gif-maker.gif'
import raulitoImg from '../assets/img/projects/raulito.gif'
import koreImg from '../assets/img/projects/kore-ezgif.com-animated-gif-maker.gif'
import mercantilImg from '../assets/img/projects/mercantilandina.gif'
import ahoramasvolvoImg from '../assets/img/projects/ahoramasvolvo-preview.png'
import ceroaccidentesImg from '../assets/img/projects/ceroaccidentes-preview.png'
import volvotrucksImg from '../assets/img/projects/volvotrucks-preview.png'
import wehostImg from '../assets/img/projects/wehost-preview.png'
import solucionesLaserImg from '../assets/img/projects/soluciones-laser.jpg'
import blackFoxImg from '../assets/img/projects/rectificadora-blackfox.jpg'

import SplitHalfTransition from './SplitHalfTransition';
import ScrollCue from './ScrollCue';

import { useTranslation } from 'react-i18next';

function Projects() {
    const { t } = useTranslation();
    useTiltEffect('.proj-imgbx');

    const projects = useMemo(() => [
        {
            title: "GAME-COMMERCE",
            description: t('projects.game_desc'),
            tech: t('projects.game_tech'),
            imgUrl: gameCommerceImg,
            deploy: "https://game-commerce-front.vercel.app/",
            github: "https://github.com/facucorona",
        },
        {
            title: "SoyHenry Pokédex",
            description: t('projects.pokedex_desc'),
            tech: t('projects.pokedex_tech'),
            imgUrl: pokedexImg,
            deploy: "https://pokemon-pi-facucorona.vercel.app/home",
            github: "https://github.com/facucorona",
        },
        {
            title: "FREAK & GEEK",
            description: t('projects.freakgeek_desc'),
            tech: t('projects.freakgeek_tech'),
            imgUrl: freakGeekImg,
            deploy: "https://freak-and-geek-culture.vercel.app/",
            github: "https://github.com/facucorona",
        },
        {
            title: "AC Estudio",
            description: t('projects.acestudio_desc'),
            tech: t('projects.acestudio_tech'),
            imgUrl: acEstudioImg,
            deploy: "https://inmobiliaria-full.vercel.app/",
            github: "https://github.com/facucorona",
        },
    ], [t])

    const clientProjects = useMemo(() => [
        { title: "Mercantil Andina", description: t('projects.mercantil_desc'), tech: "WordPress · React Intranet · Custom Dev", imgUrl: mercantilImg, deploy: "https://www.mercantilandina.com.ar" },
        { title: "Volvo Trucks Argentina", description: t('projects.volvotrucks_desc'), tech: "Adobe Experience Manager (AEM)", imgUrl: volvotrucksImg, deploy: "https://www.volvotrucks.com.ar/es-ar/" },
        { title: "Cero Accidentes", description: t('projects.ceroaccidentes_desc'), tech: "WordPress · Corporate Site", imgUrl: ceroaccidentesImg, deploy: "https://ceroaccidentes.ar" },
        { title: "Trompo Agencia", description: t('projects.trompo_desc'), tech: "WordPress · React · Custom Plugins", imgUrl: trompoImg, deploy: "https://trompoagencia.com" },
        { title: "KORE Studio", description: t('projects.kore_desc'), tech: "WordPress · Elementor · Custom Plugins", imgUrl: koreImg, deploy: "https://korestudio.com.ar" },
        { title: "Ranko", description: t('projects.ranko_desc'), tech: "WordPress · WooCommerce · E-Commerce", imgUrl: rankoImg, deploy: "https://tienda.ranko.com.ar" },
        { title: "Humming Home Services", description: t('projects.humming_desc'), tech: "WordPress · WooCommerce", imgUrl: hummingImg, deploy: "https://humminghomeservices.au" },
        { title: "iWalkWithU", description: t('projects.iwalk_desc'), tech: "WordPress · Custom Theme", imgUrl: iwalkImg, deploy: "https://iwalkwithu.com/inicio" },
        { title: "Grupo EON", description: t('projects.eon_desc'), tech: "WordPress · Corporate Site", imgUrl: eonImg, deploy: "https://grupoeon.com.ar" },
        { title: "Productos Raulito", description: t('projects.raulito_desc'), tech: "WordPress · WooCommerce · E-Commerce", imgUrl: raulitoImg, deploy: "https://productosraulito.com.ar" },
        { title: "Ahora Más Volvo", description: t('projects.ahoramasvolvo_desc'), tech: "WordPress · React · E-Commerce", imgUrl: ahoramasvolvoImg, deploy: "https://ahoramasvolvo.com.ar" },
        { title: "WeHostBsAs", description: t('projects.wehost_desc'), tech: "WordPress · Custom Design", imgUrl: wehostImg, deploy: "https://wehostbsas.com" },
        { title: "Soluciones Láser Córdoba", description: t('projects.solucioneslaser_desc'), tech: "WordPress · Elementor · Corporate Site", imgUrl: solucionesLaserImg, deploy: "https://solucioneslasercordoba.com" },
        { title: "Black Fox", description: t('projects.blackfox_desc'), tech: "WordPress · Elementor · Corporate Site", imgUrl: blackFoxImg, deploy: "https://rectificadorablackfox.com" },
    ], [t])

    // Carrusel personal: una card por proyecto (sin duplicados).
    const personalFotos = useMemo(() => projects.map((p) => p.imgUrl), [projects]);

    const clientFotos = useMemo(() => clientProjects.map((p) => p.imgUrl), [clientProjects]);

    // Mapeo índice de foto -> proyecto (para mostrar título/descripción del card activo)
    const personalData = useMemo(() => personalFotos.map((_, i) => projects[i]), [personalFotos, projects]);
    const clientData = useMemo(() => clientFotos.map((_, i) => i < clientProjects.length ? clientProjects[i] : { title: `Project ${i + 1}`, description: 'Placeholder project', tech: 'TBD' }), [clientFotos, clientProjects]);

    const [personalActive, setPersonalActive] = useState(0);
    const [clientActive, setClientActive] = useState(0);

    const titleFont = { fontSize: '20px', fontWeight: 700, lineHeight: '1.2em', letterSpacing: '-0.01em', fontFamily: 'Quicksand, sans-serif' };
    const subtitleFont = { fontSize: '13px', fontWeight: 500, lineHeight: '1.35em', letterSpacing: '0em', fontFamily: 'Quicksand, sans-serif' };

    return (
        <section className="project" id="project">
            <Container>
                <Row>
                    <Col size={12}>
                        <div className="project-bx">
                            <TrackVisibility>
                                {({ isVisible }) =>
                                    <div className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                                        <h2>{t('projects.title')}</h2>
                                        <p>{t('projects.p1')}</p>
                                        <p>{t('projects.p2')}</p>
                                    </div>}
                            </TrackVisibility>
                            <Tab.Container id="projects-tabs" defaultActiveKey="first">
                                <div className="ul-project-tabs" style={{ position: 'sticky', top: 0, zIndex: 10, padding: '12px 16px', marginBottom: '16px' }}>
                                    <Nav variant="pills" className="nav-pills mb-0 justify-content-center align-items-center" id="pills-tab">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">{t('projects.tab1')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">{t('projects.tab2')}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">{t('projects.tab3')}</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <Tab.Content className="mt-3">
                                    <Tab.Pane eventKey="first">
                                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0', minHeight: '460px' }}>
                                            <SplitHalfTransition
                                                fotos={personalFotos}
                                                title={personalData[personalActive]?.title || 'Personal Projects'}
                                                subtitle={personalData[personalActive]?.description || 'Selected personal projects'}
                                                textColor="#e0e0e0"
                                                width={560}
                                                height={420}
                                                gapZ={40}
                                                duration={0.7}
                                                scrollThreshold={40}
                                                loop={true}
                                                titleFont={titleFont}
                                                subtitleFont={subtitleFont}
                                                textLift={0}
                                                textSide={20}
                                                onChange={setPersonalActive}
                                                hrefs={personalData.map((p) => p.deploy)}
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0', minHeight: '460px' }}>
                                            <SplitHalfTransition
                                                fotos={clientFotos}
                                                title={clientData[clientActive]?.title || 'Client Work'}
                                                subtitle={clientData[clientActive]?.description || 'Selected client projects'}
                                                textColor="#e0e0e0"
                                                width={560}
                                                height={420}
                                                gapZ={40}
                                                duration={0.7}
                                                scrollThreshold={40}
                                                loop={true}
                                                titleFont={titleFont}
                                                subtitleFont={subtitleFont}
                                                textLift={0}
                                                textSide={20}
                                                onChange={setClientActive}
                                                hrefs={clientData.map((p) => p.deploy)}
                                            />
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="third">{t('projects.nothing')}</Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
                                <ScrollCue borderColor="#e0e0e0" iconColor="#e0e0e0" backgroundColor="transparent" mouseWidth={21} mouseHeight={35} dotSize={4} borderWidth={1} borderRadius={14} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Projects